import { useMemo } from 'react';
import { useAllBook } from 'store/books/selectors';
import { ebookConfigDinamic } from 'utils/lib/ebookHelper';

export const useBookDataUnits = (chapter, pageId, engageOriginal=[]) => {
  const booksAllList = useAllBook();
  const data = chapter ? ebookConfigDinamic(chapter, booksAllList) : [];

  const engage = useMemo(() => {
    const orderedEngage =  [...engageOriginal]?.sort((a, b) => Number(a.pageId) - Number(b.pageId));
    const addSequence = orderedEngage.map((item, index) => ({...item, sequence: index + 1}));
    return addSequence;
  }, [engageOriginal]);


  const haveEngageOption = useMemo(() => {
    const page = Number(pageId);
    const filterEngage = engage?.filter((item) => Number(item.pageId) === Number(page));
    return filterEngage?.length > 0;
  }, [engage, pageId]);

  // for place engage units in content
  const getAllEngageOptionBetweenUnit = (start, finish) => {
    try {
      const startPage = Number(start);
      const finishPage = Number(finish);

      if (isNaN(startPage) || isNaN(finishPage)) {
        return [];
      }

      const filteredEngage = engage?.filter((item) => {
        const page = Number(item.pageId);
        return page >= startPage && page <= finishPage;
      });

      return filteredEngage || [];
    } catch (error) {
      console.log(error, "error in getAllEngageOptionBetweenUnit");
      return [];
    }
  };

  return {
    engage,
    structures: data?.structures,
    haveEngageOption: haveEngageOption,
    getAllEngageOptionBetweenUnit: getAllEngageOptionBetweenUnit,
    
  };
};
